/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  CardContent,
  Segment,
  CardGroup,
  Header,
  Button,
  Image,
  Accordion,
  Icon,
  Grid,
} from 'semantic-ui-react';

import { Map, markers, Marker } from './map';
import { Wrapper } from '@googlemaps/react-wrapper';

import LocationMapIcon from '../../../assets/locationMapIcon.svg';

interface BranchProps {
  widthScreen?: any;
}

const Branch: React.FC<BranchProps> = props => {
  const { widthScreen } = props;

  const [openClose, setOpenClose] = useState(false);

  const openMenuMap = () => {
    setOpenClose(true);
    document.documentElement.style.setProperty('--menuMapDoor', '380px');
    if (openClose) {
      document.documentElement.style.setProperty('--menuMapDoor', '60px');
      setOpenClose(false);
    }
  };
  //Accordion Function
  const [activeIndex, setActiveIndex] = useState(0);
  const [nameCity, setNameCity] = useState<string>('Home');

  const [tagCity, setTagCity] = useState<any>({
    lon: -97.5353938095054,
    lat: 19.226375899499534,
    zoom: 4.5,
  });
  const [newMakers, setNewMakers] = useState<any>(markers);

  const handleClick = (index: any) => {
    setTagCity({ lon: index.lon, lat: index.lat, zoom: 16 });
    setNewMakers([{ lat: index.lat, lng: index.lon }]);
    setActiveIndex(index.number);
    if (activeIndex === index.number) {
      setNameCity(index.city);
      if (nameCity === 'Home') {
        setTagCity({
          lat: 20.212057419924395,
          lon: -100.0593107124024,
          zoom: 2.5,
        });
      }

      if (nameCity === 'Querétaro') {
        setTagCity({
          lat: 20.63173,
          lon: -100.40129,
          zoom: 9,
        });
      }
      if (nameCity === 'CDMX') {
        setTagCity({
          lat: 19.447667309761027,
          lon: -99.1889399334488,
          zoom: 9,
        });
      }
      if (nameCity === 'Jalisco') {
        setTagCity({
          lat: 19.702682188668255,
          lon: -101.20475119667694,
          zoom: 9,
        });
      }
      if (nameCity === 'Puebla') {
        setTagCity({
          lat: 19.035753375112034,
          lon: -98.21417827167029,
          zoom: 9,
        });
      }
      if (nameCity === 'Hidalgo') {
        setTagCity({
          lat: 20.03046422303579,
          lon: -98.80372720120018,
          zoom: 9,
        });
      }
      if (nameCity === 'Sinaloa') {
        setTagCity({
          lat: 24.79292430733445,
          lon: -107.39347549913678,
          zoom: 9,
        });
      }
      if (nameCity === 'Michoacan') {
        setTagCity({
          lat: 19.678520289263812,
          lon: -101.22424071534256,
          zoom: 9,
        });
      }
      if (nameCity === 'San Luis Potosí') {
        setTagCity({
          lat: 22.1538727,
          lon: -101.0056081,
          zoom: 9,
        });
      }
      setNewMakers(markers);
      setActiveIndex(-1);
    }
  };
  //Queretaro
  const ubications1 = [
    {
      number: 1,
      city: 'Querétaro',
      title1: 'Loma Dorada',
      title2: 'Blvd. B. Quintana, 76060',
      site: 'Blvd.  B. Quintana Nº 161, Col. Loma Dorada',
      subTitle2: 'Loma Dorada',
      contentLeftColumn:
        'lomadorada@integralogis.com.mx \n|||||||  C.P. 76060 |||||||\n  Tel. (442) 223 06 88 ',
      contentRightColumn: 'L-V 8-20, S 9-16',
      lon: -100.36755616626246,
      lat: 20.59272412297873,
    },
    {
      number: 2,
      city: 'Querétaro',
      title1: 'Plaza del Parque',
      title2: 'Plaza del Parque, 76169',
      site: 'Plaza del Parque, Prol Corregidora Norte No 691 Edificio E Locales 1 y 2 CP 76169',
      subTitle2: 'Plaza del Parque',
      contentLeftColumn:
        'plazadelparque@integralogis.com.mx \n|||||||  C.P. 76169 |||||||\n  Tel. (442) 223 36 46',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -100.3907516,
      lat: 20.6138859,
    },
    {
      number: 3,
      city: 'Querétaro',
      title1: 'Plaza de las Americas',
      title2: 'Plaza de las Americas, 76050',
      site: 'Plaza de las Américas, Av. Panamá Local 314, Carretas CP 76050',
      subTitle2: 'Plaza de las Americas',
      contentLeftColumn:
        'americas@integralogis.com.mx \n|||||||  C.P. 76050 |||||||\n  Tel. (442) 248 33 37',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -100.37260119509745,
      lat: 20.588250003044532,
    },
    {
      number: 4,
      city: 'Querétaro',
      title1: 'Plaza Bal',
      title2: 'Plaza Bal, 76125',
      site: 'Plaza Bal, Blvd Bernardo Quintana 630 local 2, Desarrollo San Pablo CP 76125',
      subTitle2: 'Plaza Bal',
      contentLeftColumn:
        'plazabal@integralogis.com.mx \n|||||||  C.P. 76125 |||||||\n  Tel. (442) 223 72 08',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -100.4100183,
      lat: 20.6196397,
    },
    {
      number: 5,
      city: 'Querétaro',
      title1: 'Plaza El Pocito',
      title2: 'Plaza El Pocito, 76902',
      site: 'Av. Constituyentes No. 47 local 6 Col. El Pocito CP 76902',
      subTitle2: 'Plaza El Pocito',
      contentLeftColumn:
        'pocito@integralogis.com.mx \n|||||||  C.P. 76902 |||||||\n  Tel. (442) 196 85 58',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -100.4501558,
      lat: 20.549838,
    },
  ];
  // CDMX
  const ubications4 = [
    {
      number: 1,
      city: 'CDMX',
      title1: 'Camarones',
      title2: 'Camarones, 02060',
      site: 'Norte 83 no. 326 local B, Col. Sindicato Mexicano de Electricista CP 02060',
      subTitle2: 'Camarones',
      contentLeftColumn:
        'camarones@bitenvios.com \n|||||||  C.P.  02060 |||||||\n  Tel. (55) 1549 1107',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -99.17854204048099,
      lat: 19.471316623507136,
    },
    {
      number: 2,
      city: 'CDMX',
      title1: 'Calzada de Tlalpan',
      title2: 'Calz. De Tlalpan, 03510',
      site: 'Calz. De Tlalpan 610 local A, Col. Moderna CP 03510',
      subTitle2: 'Calzada de Tlalpan',
      contentLeftColumn:
        'ctlalpan@bitenvios.com \n|||||||  C.P.  03510 |||||||\n  Tel. (55) 2609 9289',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -99.1373705,
      lat: 19.3961934,
    },
    {
      number: 3,
      city: 'CDMX',
      title1: 'República de Perú',
      title2: 'República de Perú, 06000',
      site: 'República de Perú 61 local A, Centro CP 06000',
      subTitle2: 'República de Perú',
      contentLeftColumn:
        'mex.peru@inabitmexico.com \n|||||||  C.P. 06000 |||||||\n  Tel. (55) 1056 3029',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -99.1357400981519,
      lat: 19.439637147994443,
    },
    {
      number: 5,
      city: 'CDMX',
      title1: 'Rojo Gomez',
      title2: 'Rojo Gomez, 09310',
      site: 'Av. Rojo Gómez 726 local A, Col. Leyes de Reforma 3ra Sección, CP 09310',
      subTitle2: 'Rojo Gomez',
      contentLeftColumn:
        'mex.rojogómez@inabitmexico.com \n|||||||  C.P. 09310 |||||||\n  Tel. (55) 5640 6201',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -99.07801049999999,
      lat: 19.37570209974448,
    },
    {
      number: 6,
      city: 'CDMX',
      title1: 'Marina Nacional',
      title2: 'Marina Nacional, 11320',
      site: 'Av. Marina Nacional 330 local F1, Col. Anahuac I, CP 11320',
      subTitle2: 'Marina Nacional',
      contentLeftColumn:
        'marina.nacional@inabitmexico.com \n|||||||  C.P. 09310 |||||||\n  Tel. (55) 2589 8898',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -99.17461123124043,
      lat: 19.440121730457122,
    },
    {
      number: 8,
      city: 'CDMX',
      title1: 'Tacuba',
      title2: 'Legaria, 11410',
      site: 'Calzada Legaria 22 local D, Col. Tacuba, C.P. 11410',
      subTitle2: 'Tacuba',
      contentLeftColumn:
        'mex.legaria@inabitmexico.com \n|||||||  C.P. 11410 |||||||\n  Tel. (55) 2793 5835',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -99.1918403,
      lat: 19.4579221,
    },
  ];

  // Jalisco
  const ubications3 = [
    {
      number: 1,
      city: 'Jalisco',
      title1: 'Plaza Lisboa',
      title2: 'Plaza Lisboa, 44240',
      site: 'Plaza Lisboa Calzada Independencia Norte No. 2175-21, Col. Monte Tabor Monserrat Independencia C.P. 44240',
      subTitle2: 'Plaza Lisboa',
      contentLeftColumn:
        'gdl.plazalisboa@inabitmexico.com\n|||||||  C.P. 37266 |||||||\n  Tel. (333) 699 3746',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -103.3248754,
      lat: 20.7073113,
    },
  ];
  // Puebla
  const ubications5 = [
    {
      number: 1,
      city: 'Puebla',
      title1: 'Puebla',
      title2: 'Puebla, 72000',
      site: ' Calle 7 Poniente 501 Local 1, Col Centro CP 72000',
      subTitle2: 'Puebla',
      contentLeftColumn:
        ' pbc.centro@enviosinabit.com \n|||||||  C.P.  72000 |||||||\n  Tel. (222) 2253 485 ',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -98.2033005,
      lat: 19.04387,
    },
  ];


  //Hidalgo
  const ubications7 = [
    {
      number: 1,
      city: 'Pachuca',
      title1: 'Pachuca Matilde',
      title2: 'Pachuca Matilde, 42111',
      site: 'Carretera Federal Pachuca - Mexico km 80.5 Local 2, CP 42111',
      subTitle2: 'Pachuca Matilde',
      contentLeftColumn:
        ' pca.matilde@inabitmexico.com \n|||||||  C.P.  42111 |||||||\n  Tel. (771) 106 1369 ',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -98.80372720120018,
      lat: 20.03046422303579,
    },
  ];

  //Sinaloa
  const ubications8 = [
    {
      number: 1,
      city: 'Culiacan',
      title1: 'Culiacan Guadalupe',
      title2: 'Culiacan Guadalupe, 80220',
      site: 'Prol. Álvaro Obregón 1215 Local 1 CP 80220',
      subTitle2: 'Culiacan Guadalupe',
      contentLeftColumn:
        ' pcm.xelha@inabitmexico \n|||||||  C.P.  80220 |||||||\n  Tel. (667) 332 1639 ',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -107.39347549913678,
      lat: 24.79292430733445,
    },
  ];
  //Michoacan
  const ubications9 = [
    {
      number: 1,
      city: 'Morelia',
      title1: 'Morelia Bustamante',
      title2: 'Morelia Bustamante, 58197',
      site: 'Periodista Bustamante # 120, CP 58197',
      subTitle2: 'Morelia Bustamante',
      contentLeftColumn:
        ' mlm.bustamante@inabitmexico.com \n|||||||  C.P.  58197 |||||||\n  Tel. 4433049344 ',
      contentRightColumn: 'L-V 9-19, S 9-14',
      lon: -101.22424071534256,
      lat: 19.678520289263812,
    },
  ];
  //SLP
  const ubications10 = [
    {
      number: 1,
      city: 'San Luis Potosí',
      title1: 'IN A BIT DEL VALLE',
      title2: 'Av Nereo Rodríguez Barragán 721-B',
      site: 'Av Nereo Rodríguez Barragán 721-B, Col del Valle, 78200 San Luis Potosí, S.L.P.',
      subTitle2: 'IN A BIT DEL VALLE',
      contentLeftColumn:
        'slp.delvalle@inabitmexico.com\nC.P.  78200\nTeléfonos: 456 104 4708',
      contentRightColumn: 'L-V 9-7pm, S 9-2pm',
      lon: -101.0056081,
      lat: 22.1538727,
    },
  ];

  const [selectCity, setSelectCity] = useState<any>(ubications1);

  useEffect(() => {
    if (activeIndex === -1) setNewMakers(markers);
  }, [nameCity, newMakers]);

  const orderAlphabetically = (array: any, field: string) =>
    array.sort((a: any, b: any) => {
      let titleA = a[field].toUpperCase(); // ignore case
      let titleB = b[field].toUpperCase(); // ignore case
      if (titleA < titleB) {
        return -1;
      }
      if (titleA > titleB) {
        return 1;
      }
      return 0;
    });

  return (
    <Segment id='section6'>
      <CardGroup className='mt-10 flex flex-row justify-between'>
        {/* Left Column */}
        <CardContent id='leftColumnMap'>
          <CardContent id='map'>
            <CardGroup id='menuSection6'>
              {
                /* widthScreen >= 750 && */ <Header
                  id='titleSection6'
                  content='Ubica nuestras sucursales'
                />
              }
              {/* {widthScreen < 750 && (
                <CardGroup>
                  <Header
                    id='titleSection6'
                    content='Ubica nuestras sucursales'
                  />
                  <Button
                    icon='bars'
                    id='menuIconMap'
                    onClick={() => openMenuMap()}
                  />
                </CardGroup>
              )} */}
              {/* {widthScreen < 1550 && (
                <CardContent id='menuItemMap'>
                  <br />
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications1);
                      setTagCity({ lat: 20.63173, lon: -100.40129, zoom: 9 });
                      setNewMakers(markers);
                    }}
                  >
                    Querétaro
                  </p>
                  <br />
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications4);
                      setTagCity({
                        lat: 19.447667309761027,
                        lon: -99.1889399334488,
                        zoom: 9,
                      });
                      setNewMakers(markers);
                    }}
                  >
                    CDMX
                  </p>
                  <br />
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications2);
                      setTagCity({ lat: 21.121673, lon: -101.66002, zoom: 9 });
                      setNewMakers(markers);
                    }}
                  >
                    Guanajuato
                  </p>
                  <br />
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications3);
                      setTagCity({ lat: 20.706979, lon: -103.32488, zoom: 9 });
                      setNewMakers(markers);
                    }}
                  >
                    Jalisco
                  </p>
                  <br />
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications5);
                      setTagCity({
                        lat: 19.04413591106933,
                        lon: -98.20342100266858,
                        zoom: 9,
                      });
                      setNewMakers(markers);
                    }}
                  >
                    Puebla
                  </p>
                  <br />
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications6);
                      setTagCity({
                        lat: 20.681194693301673,
                        lon: -87.04618895582279,
                        zoom: 9,
                      });
                      setNewMakers(markers);
                    }}
                  >
                    Quintana Roo
                  </p>
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications7);
                      setTagCity({
                        lat: 20.12870211709786,
                        lon: -98.73099590659447,
                        zoom: 9,
                      });
                      setNewMakers(markers);
                    }}
                  >
                    Pachuca
                  </p>
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications8);
                      setTagCity({
                        lat: 24.79292430733445,
                        lon: -107.39347549913678,
                        zoom: 9,
                      });
                      setNewMakers(markers);
                    }}
                  >
                    Culiacan
                  </p>
                  <p
                    id='btnMenuMap'
                    onClick={() => {
                      openMenuMap();
                      setSelectCity(ubications9);
                      setTagCity({
                        lat: 19.678520289263812,
                        lon: -101.22424071534256,
                        zoom: 9,
                      });
                      setNewMakers(markers);
                    }}
                  >
                    Morelia
                  </p>
                </CardContent>
              )} */}
            </CardGroup>
            <Wrapper apiKey={'AIzaSyBWA6IVq5UcsUYb7L94Vc_qwAtDDKV6fw8'}>
              <Map
                center={{ lat: tagCity.lat, lng: tagCity.lon }}
                zoom={tagCity.zoom}
                style={{ flexGrow: '1', height: '100%' }}
                onClick={undefined}
                onIdle={undefined}
              >
                {newMakers.map((marker: any) => {
                  return <Marker position={marker} />;
                })}
              </Map>
            </Wrapper>{' '}
          </CardContent>
        </CardContent>
        {/* Right Column */}
        <CardContent id='rightColumnMap'>
          {/* input search */}
          {/*   <CardGroup id='inputGroupMap'>
            <Input id='inputServiceLargeMap' placeholder='Ingresa tu municipio o ciudad…' />
            <Button id='btnServicesMap' icon='search' content='Buscar' />
          </CardGroup> */}
          <CardContent id='menuContainerSection6'>
            {
              <CardGroup className='states-cards'>
                <Button
                  id={
                    nameCity === 'Home'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setNameCity('Home');
                    setNewMakers(markers);
                    setTagCity({
                      lat: 20.212057419924395,
                      lon: -100.0593107124024,
                      zoom: 4.5,
                    });
                  }}
                  icon='home'
                />
                <Button
                  id={
                    nameCity === 'Querétaro'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications1, 'title1'));
                    setNameCity('Querétaro');
                    setNewMakers(markers);
                    setTagCity({ lat: 20.63173, lon: -100.40129, zoom: 9 });
                  }}
                  content='Querétaro'
                />
                <Button
                  id={
                    nameCity === 'CDMX'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications4, 'title1'));
                    setNameCity('CDMX');
                    setNewMakers(markers);
                    setTagCity({
                      lat: 19.447667309761027,
                      lon: -99.1889399334488,
                      zoom: 9,
                    });
                  }}
                  content='CDMX'
                />

                <Button
                  id={
                    nameCity === 'Jalisco'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications3, 'title1'));
                    setNameCity('Jalisco');
                    setNewMakers(markers);
                    setTagCity({ lat: 20.706979, lon: -103.32488, zoom: 9 });
                  }}
                  content='Jalisco'
                />
                <Button
                  id={
                    nameCity === 'Puebla'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications5, 'title1'));
                    setNameCity('Puebla');
                    setNewMakers(markers);
                    setTagCity({
                      lat: 19.04413591106933,
                      lon: -98.20342100266858,
                      zoom: 9,
                    });
                  }}
                  content='Puebla'
                />
                <Button
                  id={
                    nameCity === 'Hidalgo'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications7, 'title1'));
                    setNameCity('Hidalgo');
                    setNewMakers(markers);
                    setTagCity({
                      lat: 20.03046422303579,
                      lon: -98.80372720120018,
                      zoom: 9,
                    });
                  }}
                  content='Hidalgo'
                />


                <Button
                  id={
                    nameCity === 'Sinaloa'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications8, 'title1'));
                    setNameCity('Sinaloa');
                    setNewMakers(markers);
                    setTagCity({
                      lat: 24.79292430733445,
                      lon: -107.39347549913678,
                      zoom: 9,
                    });
                  }}
                  content='Sinaloa'
                />
                <Button
                  id={
                    nameCity === 'Michoacan'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications9, 'title1'));
                    setNameCity('Michoacan');
                    setNewMakers(markers);
                    setTagCity({
                      lat: 19.678520289263812,
                      lon: -101.22424071534256,
                      zoom: 9,
                    });
                  }}
                  content='Michoacan'
                />
                <Button
                  id={
                    nameCity === 'San Luis Potosí'
                      ? 'btnMenuSection6Active'
                      : 'btnMenuSection6'
                  }
                  onClick={() => {
                    setSelectCity(orderAlphabetically(ubications10, 'title1'));
                    setNameCity('San Luis Potosí');
                    setNewMakers(markers);
                    setTagCity({
                      lat: 22.1538727,
                      lon: -101.0056081,
                      zoom: 9,
                    });
                  }}
                  content='San Luis Potosí'
                />
              </CardGroup>
            }
          </CardContent>
          <CardContent id='cardContentAccordion'>
            {selectCity !== null && (
              <>
                {/* Accordion */}
                {selectCity.map((item: any, key: number) => (
                  <Accordion
                    id='acordionLocation'
                    key={key}
                  >
                    <Accordion.Title
                      onClick={() => {
                        handleClick(item);
                      }}
                    >
                      <CardGroup id='cardLocation'>
                        <CardGroup id='contentHeaderDropdown1'>
                          <Image
                            id='IconUbication'
                            src={LocationMapIcon}
                          />
                          <Header
                            id='dropUbicationHeader'
                            content={item.title1}
                            subheader={item.subTitle2}
                          />
                        </CardGroup>
                        <CardGroup id='contentHeaderDropdown2'>
                          <Header
                            id='dropUbicationHeader2'
                            content={item.title2}
                            subheader={
                              <p id='subheader2Ubication'>{item.site}</p>
                            }
                          />
                          <Icon
                            id='iconDropDown'
                            name={
                              activeIndex === item.number
                                ? 'angle up'
                                : 'angle down'
                            }
                          />
                        </CardGroup>
                      </CardGroup>
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === item.number}>
                      <Grid
                        id='gridContentLocation'
                        columns='equal'
                      >
                        <Grid.Column>
                          <p id='textRevealAcordion'>
                            {item.contentLeftColumn}
                          </p>
                        </Grid.Column>
                        <Grid.Column>
                          <p id='textRevealAcordion2'>
                            {item.contentRightColumn}
                          </p>
                        </Grid.Column>
                      </Grid>
                    </Accordion.Content>
                  </Accordion>
                ))}
              </>
            )}
          </CardContent>
        </CardContent>
      </CardGroup>
    </Segment>
  );
};

export default Branch;
